import { StationSelection } from './../../model/station-selection';
import { StationSelectionLevel } from '../../model/StationSelectionLevel.enum';
import { StationGroup } from './../../model/StationGroup';
import { Component, Input, OnInit, Output, EventEmitter, AfterViewInit } from '@angular/core';
import { StationSet } from '../../model/StationSet';
import { Station } from '../../model/Station';
import { StationType } from '../../model/StationType.enum';
import { TranslationService } from '@sdbn/common';

@Component({
  selector: 'app-station-selection',
  templateUrl: './station-selection.component.html',
  styleUrls: ['./station-selection.component.scss']
})
export class StationSelectionComponent implements OnInit, AfterViewInit {

  autoConfirmLevel: StationSelectionLevel;

  @Input() selection: StationSelection = new StationSelection();
  @Input() stationGroups: StationGroup[] = [];
  @Input() requiredSelectionLevels: StationSelectionLevel[];
  @Input() includeStations = true;
  @Input() includeWaitingareas = false;

  @Output() selectionChanged = new EventEmitter<StationSelection>();
  @Output() selectionCompleted = new EventEmitter<StationSelection>();

  constructor(public translationService: TranslationService) { }

  ngOnInit() {

    const levelPrio: StationSelectionLevel[] = [];
    levelPrio.push(StationSelectionLevel.NONE);
    levelPrio.push(StationSelectionLevel.STATION_GROUP);
    levelPrio.push(StationSelectionLevel.STATION_SET);
    levelPrio.push(StationSelectionLevel.STATION);

    let prioLevel = 0;
    for (const lvl of this.requiredSelectionLevels) {

      const prioIndex = levelPrio.indexOf(lvl);
      if (prioIndex > prioLevel) {
        prioLevel = prioIndex;
        this.autoConfirmLevel = lvl;
      }

    }
  }

  ngAfterViewInit(): void {
    this.selection.valid = this.isSelectionValid();
    this.selectionChanged.next(this.selection);
  }

  public setSelectedStationGroup(sg: StationGroup) {

    if (this.isStationGroupSelected(sg)) {
      this.selection.stationGroup = null;
      this.selection.stationSet = null;
      this.selection.station = null;
      this.selection.valid = this.isSelectionValid();

      this.selectionChanged.next(this.selection);

    } else {
      this.selection.stationGroup = sg;
      this.selection.stationSet = null;
      this.selection.station = null;
      this.selection.valid = this.isSelectionValid();

      this.selectionChanged.next(this.selection);

      if (this.autoConfirmLevel === StationSelectionLevel.STATION_GROUP) {
        this.selectionCompleted.next(this.selection);
      }
    }
  }

  public isStationGroupSelected(sg: StationGroup): boolean {
    return this.selection.stationGroup != null && this.selection.stationGroup.id === sg.id;
  }

  public setSelectedStationSet(set: StationSet) {


    if (this.isStationSetSelected(set)) {
      this.selection.stationSet = null;
      this.selection.station = null;
      this.selection.valid = this.isSelectionValid();

      this.selectionChanged.next(this.selection);

    } else {
      this.selection.stationSet = set;
      this.selection.station = null;
      this.selection.valid = this.isSelectionValid();

      this.selectionChanged.next(this.selection);

      if (this.autoConfirmLevel === StationSelectionLevel.STATION_SET) {
        this.selectionCompleted.next(this.selection);
      }
    }
  }

  public isStationSetSelected(set: StationSet): boolean {
    return this.selection.stationSet != null && this.selection.stationSet.id === set.id;
  }

  public setSelectedStation(station: Station) {

    if (this.isStationSelected(station)) {
      this.selection.station = null;
      this.selection.valid = this.isSelectionValid();

      this.selectionChanged.next(this.selection);

    } else {
      this.selection.station = station;
      this.selection.valid = this.isSelectionValid();

      this.selectionChanged.next(this.selection);

      if (this.autoConfirmLevel === StationSelectionLevel.STATION) {
        this.selectionCompleted.next(this.selection);
      }
    }
  }

  public isStationSelected(station: Station): boolean {
    return this.selection.station != null && this.selection.station.id === station.id;
  }

  public getStations(stationSet: StationSet) {
    if (stationSet == null) {
      return [];
    }

    if (this.includeWaitingareas) {
      return stationSet.stations;
    } else {
      return stationSet.stations.filter(s => s.stationType === StationType.WORKING_AREA);
    }
  }

  private isSelectionValid() {

    let selectedLevel = null;

    if (this.selection.station != null) {
      selectedLevel = StationSelectionLevel.STATION;
    } else if (this.selection.stationSet != null) {
      selectedLevel = StationSelectionLevel.STATION_SET;
    } else if (this.selection.stationGroup != null) {
      selectedLevel = StationSelectionLevel.STATION_GROUP;
    } else if (this.requiredSelectionLevels.indexOf(StationSelectionLevel.NONE) !== -1) {
      return true;
    }

    return this.requiredSelectionLevels.indexOf(selectedLevel) !== -1;

  }
}
